export class EventBasicInfo {
    // uniqueId: string;
    aliasId: string;
    name: string;
    eventId: string;
    isEventPublic: boolean;
    startTime: string;
    endTime: string;
    locationShort: string;
    locationAddress: string;
    latitude: number;
    longitude: number;
    // description: string;
    show :boolean;
  }
  


// WEBPACK FOOTER //
// /workspace/backend-server/src/app/core/models/event-basic-info.ts